/* RESPONSIBLE TEAM: team-frontend-tech */
export default {
  name: 'vertical-collection-debug',
  initialize() {},
};
